require("../lib-sass/health.scss");
require("../sass/help.scss");
var $ = require("jquery");
$(".business-btn").on('click', function () {
    $(".drug-box").show();
});
$(".drug-box").on('mouseleave click', function () {
    $(".drug-box").hide();
});


/*****************
 ** WEBPACK FOOTER
 ** ./pages/home/js/help.js
 ** module id = 0
 ** module chunks = 5
 **/